/**
 * DONO DO DOM — Base Custom Scripts
 * Standard: Native Web Components & Vanilla JS
 */

(function() {
  'use strict';

  // Base DDC Helper Utilities
  window.DDC = window.DDC || {};
  window.DDC.version = '1.0.0-DDC';

  // Safe Web Component registration helper
  window.DDC.defineComponent = function(name, componentClass) {
    if (!customElements.get(name)) {
      customElements.define(name, componentClass);
    }
  };

  // Initialize DDC Sticky Buy Bar scroll controller
  function initStickyBuyBar() {
    const stickyBar = document.getElementById('ddc-sticky-buy-bar');
    if (!stickyBar) return;

    // Remove existing listener if any (to prevent duplication)
    if (window.DDC.handleStickyScroll) {
      window.removeEventListener('scroll', window.DDC.handleStickyScroll);
    }

    window.DDC.handleStickyScroll = function() {
      const buyButton = document.querySelector('.product-info [name="add"], .product-info .button--primary');
      if (!buyButton) return;
      const rect = buyButton.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', window.DDC.handleStickyScroll, { passive: true });
    window.DDC.handleStickyScroll(); // Run once initially
  }

  function initExitIntentPopup() {
    const popup = document.querySelector('newsletter-popup[data-ddc-exit-intent="true"]');
    if (!popup || popup.dataset.ddcExitIntentReady === 'true') return;
    popup.dataset.ddcExitIntentReady = 'true';

    if (localStorage.getItem('theme:popup-filled') === 'true') return;
    if (popup.hasAttribute('only-once') && localStorage.getItem('theme:popup-appeared') === 'true') return;

    const threshold = Number.parseInt(popup.dataset.exitThreshold || '40', 10);
    const mobileScrollDepth = Number.parseInt(popup.dataset.mobileScrollDepth || '35', 10);
    const mobileIdleDelay = Number.parseInt(popup.dataset.mobileIdleDelay || '10', 10) * 1000;
    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    let hasTriggered = false;
    let hasQualifiedMobileScroll = false;
    let idleTimer;

    const canOpen = () => !hasTriggered && !popup.open && document.visibilityState === 'visible';
    const openPopup = () => {
      if (!canOpen() || typeof popup.show !== 'function') return;
      hasTriggered = true;
      popup.show();
    };
    const form = popup.querySelector('form');
    const generatedEmailInput = popup.querySelector('[data-ddc-generated-email]');

    if (form && generatedEmailInput) {
      form.addEventListener('submit', () => {
        if (generatedEmailInput.value) return;
        const uniqueId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        generatedEmailInput.value = `lead-whatsapp-${uniqueId}@donododom.com.br`;
      });
    }

    if (!isTouch) {
      document.addEventListener('mouseout', (event) => {
        if (event.relatedTarget !== null) return;
        if (event.clientY <= threshold) openPopup();
      }, { passive: true });
      return;
    }

    const updateMobileQualification = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
      if (progress >= mobileScrollDepth) {
        hasQualifiedMobileScroll = true;
      }
    };

    const resetIdleTimer = () => {
      if (!hasQualifiedMobileScroll || hasTriggered) return;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(openPopup, mobileIdleDelay);
    };

    window.addEventListener('scroll', () => {
      updateMobileQualification();
      resetIdleTimer();
    }, { passive: true });

    ['touchstart', 'touchmove', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, resetIdleTimer, { passive: true });
    });
  }

  // DOM Content Loaded Initializer
  document.addEventListener('DOMContentLoaded', () => {
    // Lifecycle setup for DDC interactive elements
    initStickyBuyBar();
    initExitIntentPopup();
  }, { once: true });

  // Sincronização reativa do Sticky Buy com a variante selecionada
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail.variant;
    const stickyBar = document.getElementById('ddc-sticky-buy-bar');
    if (!stickyBar) return;

    // Atualizar preço
    const priceElement = stickyBar.querySelector('.ddc-sticky-buy__price');
    if (priceElement && variant && variant.price !== undefined) {
      priceElement.textContent = (variant.price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    // Atualizar imagem
    if (variant && variant.featured_image && variant.featured_image.src) {
      const imgElement = stickyBar.querySelector('.ddc-sticky-buy__image');
      if (imgElement) {
        imgElement.src = variant.featured_image.src;
      }
    }

    // Atualizar disponibilidade do botão
    const btn = stickyBar.querySelector('.ddc-sticky-buy__btn');
    if (btn) {
      if (variant && variant.available) {
        btn.disabled = false;
        btn.classList.remove('button--disabled');
        const span = btn.querySelector('span');
        if (span) span.textContent = 'Comprar Agora';
      } else {
        btn.disabled = true;
        btn.classList.add('button--disabled');
        const span = btn.querySelector('span');
        if (span) span.textContent = 'Esgotado';
      }
    }
  });

  // Global theme loading transitions (skeleton-like interaction)
  document.addEventListener('theme:loading:start', () => {
    const productLists = document.querySelectorAll('.product-list');
    productLists.forEach(list => list.classList.add('is-loading'));

    // Predictive Search loading state
    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch && document.activeElement && predictiveSearch.contains(document.activeElement)) {
      predictiveSearch.setAttribute('loading', 'true');
    }
  });

  document.addEventListener('theme:loading:end', () => {
    const productLists = document.querySelectorAll('.product-list');
    productLists.forEach(list => list.classList.remove('is-loading'));

    // Predictive Search loading state
    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch) {
      predictiveSearch.removeAttribute('loading');
    }
  });

  // Micro-feedback visual no botão de compra ao adicionar produto
  document.addEventListener('variant:add', () => {
    const buyButtons = document.querySelectorAll('.product-info [name="add"], #ddc-sticky-buy-bar .ddc-sticky-buy__btn');
    buyButtons.forEach(btn => {
      const span = btn.querySelector('span') || btn;
      const originalText = span.textContent;
      span.textContent = 'Adicionado ✔️';
      btn.classList.add('is-added');
      setTimeout(() => {
        if (span.textContent === 'Adicionado ✔️') {
          span.textContent = originalText;
        }
        btn.classList.remove('is-added');
      }, 2000);
    });
  });
})();
